<template>
  <div class="component-form-button">
    <span class="required-message"><span>*</span>为必填信息</span>
    <a-button
      class="save-button"
      type="primary"
      shape="round"
      :loading="btnIsLoading"
      @click="$emit('onSubmit')"
    >
      保存
    </a-button>
    <a-button
      class="cancel-button"
      shape="round"
      @click="$emit('onCancel')"
    >
      取消
    </a-button>
  </div>
</template>
<script>
export default{
  props: {
    btnIsLoading: {
      type: Boolean,
    },
  },
};
</script>
<style lang="scss" scoped>
.component-form-button {
  height: 80px;
  line-height: 80px;
  background: rgba(239, 240, 247, 1);
  margin: 0 -32px -32px;
  transform: translateY(10px);
  padding: 0 24px;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  .required-message {
    span {
      color: #ff5075;
      display: inline-block;
      width: 9px;
    }
  }
  .save-button {
    float: right;
    margin-left: 10px;
    margin-top: 20px;
    width: 104px;
  }
  .cancel-button {
    float: right;
    margin-left: 10px;
    margin-top: 20px;
    width: 104px;
  }
}
</style>
